export class Forecast {
  constructor(public wind?: Wind, public sys?: Sys) {
    this.wind = new Wind();
    this.sys = new Sys();
  }
}
export class Wind {
  constructor(public speed?: number) {
    this.speed = null;
  }
}
export class Sys {
  constructor(public country?: string) {
    this.country = '';
  }
}
